export default "/images/pexels-tofroscom-359757.jpg?b0e313ca6aed0e770960781e9711acab";